import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import log from 'lib/log'
import { unpublishPost, goToPost } from 'actions/posts'
import LoadingLoadedOrExploded from 'components/LoadingLoadedOrExploded'
import ArticleList from 'components/ArticleList'
import Menu from 'components/Menu'
import MenuItem from 'components/MenuItem'

const isAdmin = membership => membership && membership.role === 'ADMIN'

const isAuthor = (target, profile) =>
  profile && target.author._id === profile._id

class ReferencesList extends Component {
  constructor(props) {
    super(props)
    this.hasOverflowMenu = this.hasOverflowMenu.bind(this)
    this.renderOverflowMenu = this.renderOverflowMenu.bind(this)
    this.handleUnpublish = this.handleUnpublish.bind(this)
  }
  async handleUnpublish(target) {
    try {
      await this.props.unpublishPost(target)
      await this.props.loadPosts({
        author: this.props.author._id
      })
    } catch (err) {
      log.error(err)
    }
  }
  hasOverflowMenu(target) {
    let { profile, membership, group } = this.props
    return isAuthor(target, profile) || (isAdmin(membership) && !group.closed)
  }
  renderOverflowMenu(target) {
    let { profile, membership, group, onShowCloseDialog } = this.props
    let items = []
    if (isAuthor(target, profile)) {
      items.push(
        <MenuItem
          key="edit"
          label="posts.edit"
          onClick={this.props.onEditClick}
        />
      )
      items.push(
        <MenuItem
          key="unpublish"
          label="posts.unpublish"
          onClick={this.handleUnpublish}
        />
      )
    }
    return <Menu context={target}>{items}</Menu>
  }
  render() {
    return (
      <ArticleList
        {...this.props}
        overflowMenu={this.renderOverflowMenu}
        hasOverflowMenu={this.hasOverflowMenu}
      />
    )
  }
}

const References = ({
  handlePostClick,
  handleEditClick,
  onShowCloseDialog,
  unpublishPost,
  loadPosts,
  profile,
  references: {
    map: content,
    list: { loading, error, values: order, range } = {}
  }
}) => {
  const loaded = content
    ? {
        content,
        order,
        range,
        unpublishPost,
        loadPosts,
        profile,
        onShowCloseDialog
      }
    : undefined
  return (
    <LoadingLoadedOrExploded
      loading={loading || !(content || error)}
      loaded={loaded}
      error={error && error.message ? error.message : error}
      loadedComponent={ReferencesList}
      onPostClick={handlePostClick}
      onEditClick={handleEditClick}
      onPinOutcomeClick={onShowCloseDialog}
    />
  )
}

const mapStateToProps = ({ references }, props) => ({ references })
const mapDispatchToProps = dispatch => {
  return {
    handlePostClick: ({ name, author: { username }, group, _id }) => {
      dispatch(goToPost({ name, username, group, _id }))
    },
    unpublishPost: bindActionCreators(unpublishPost, dispatch),
    handleEditClick: ({ draft, type }) => {
      dispatch({
        type: 'profile/drafts/_edit/compose',
        payload: {
          postType: type,
          postId: draft
        }
      })
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(References)
